import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Card = ({ 
  title, 
  subtitle, 
  children, 
  noPadding = false,
  onClick,
  sx = {},
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: isDark ? '#1a1a1a' : '#ffffff',
        borderRadius: '12px',
        border: isDark ? '1px solid rgba(255, 255, 255, 0.05)' : 'none',
        boxShadow: isDark
          ? '0 4px 12px rgba(0, 0, 0, 0.5)'
          : '0 4px 12px rgba(0, 0, 0, 0.08)',
        transition: 'all 0.3s ease',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick ? {
          transform: 'translateY(-2px)',
          boxShadow: isDark
            ? '0 8px 24px rgba(99, 102, 241, 0.2)'
            : '0 8px 24px rgba(25, 118, 210, 0.15)',
        } : {},
        ...sx,
      }}
    >
      {(title || subtitle) && (
        <Box
          sx={{
            p: noPadding ? 0 : 3,
            pb: noPadding ? 0 : 2,
            borderBottom: isDark ? '1px solid rgba(255, 255, 255, 0.05)' : '1px solid #e2e8f0',
          }}
        >
          {title && (
            <Typography
              sx={{
                fontSize: '1.125rem',
                fontWeight: 600,
                color: isDark ? '#ffffff' : '#1a202c',
                mb: subtitle ? 0.5 : 0,
              }}
            >
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography
              sx={{
                fontSize: '0.875rem',
                color: isDark ? '#cbd5e1' : '#718096',
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      )}
      <Box sx={{ p: noPadding ? 0 : 3, pt: (title || subtitle) && !noPadding ? 2 : (noPadding ? 0 : 3) }}>
        {children}
      </Box>
    </Box>
  );
};

export default Card;
